import './assets/tailwind.css';
import '@mdi/font/css/materialdesignicons.css'
import "vue-toastification/dist/index.css";


import Toast, { POSITION } from "vue-toastification";



import { createApp }       from 'vue'
import router              from './router'
import App                 from './App.vue'


const app = createApp(App);
app.use(Toast, { position: POSITION.BOTTOM_RIGHT })
app.use(router)
app.mount('#app')
